import { useCallback, useEffect, useState } from "react"

export type Appearance = "light" | "dark"

const applyTheme = (appearance: Appearance) => {
  const isDark = appearance === "dark"

  document.documentElement.classList.toggle("dark", isDark)
  document.documentElement.style.colorScheme = isDark ? "dark" : "light"
}

export function initializeTheme() {
  const savedAppearance =
    (localStorage.getItem("appearance") as Appearance) || "light"

  applyTheme(savedAppearance)
}

export function useAppearance() {
  const [appearance, setAppearance] = useState<Appearance>(() => {
    if (typeof window === "undefined") return "light"
    const saved = localStorage.getItem("appearance") as Appearance | null
    return saved ?? "light"
  })

  const updateAppearance = useCallback((mode: Appearance) => {
    setAppearance(mode)
    localStorage.setItem("appearance", mode)
    applyTheme(mode)
  }, [])

  useEffect(() => {
    applyTheme(appearance)
  }, [appearance])

  return { appearance, updateAppearance } as const
}
